import _some from "lodash/some";
import _forEach from "lodash/forEach";
import _includes from "lodash/includes";

export function pageLoader(vtAccount) {
    "use strict";

    const appState = Vistracks.Scope.AppState;

    // 1. Determine what product the current active account have
    const products = appState.attr("products");

    _forEach(Object.keys(products.serialize()), product => {
        const itHasHosModule = _includes(
            ["hosOnly", "hosAndDvir", "hosAndMobileWorker", "hosDvirAndMobileWorker"],
            product
        );
        const itHasDvirModule = _includes(["dvirOnly", "dvirAndMobileWorker"], product);

        // Is there a cache route?
        const routes = Cookies.getJSON("routes");
        if (routes) {
            _forEach(Object.keys(routes), route => can.route.attr(route, routes[route]));

            return false;
        }

        // 2. Then set a default module and page to display
        if (
            products.attr(product) &&
            itHasHosModule &&
            (vtAccount.features.eld || vtAccount.features.logbook) &&
            appState.attr("hasHosPermission")
        ) {
            can.route.attr("page", "hos");
            can.route.attr("slug", "drivers");

            return false;
        }

        if (products.attr(product) && itHasDvirModule && vtAccount.features.dvir) {
            can.route.attr("page", "dvir");
            can.route.attr("slug", "dvir-history");

            return false;
        }

        if (products.attr(product) && product === "mobileWorkerOnly" &&
            vtAccount.features.workOrder && appState.attr("hasMobileWorkerPermission")) {
            can.route.attr("page", "mobile-worker");
            can.route.attr("slug", "jobsites");

            return false;
        }
    });

    const userIsAccountAdmin = appState.permissions.PERM_IS_ACCOUNT_ADMIN,
        noProducts = !_some(Object.keys(products.serialize()), product => products.attr(product));

    const noFeatureProductsEnabled = !vtAccount.features.eld &&
        !vtAccount.features.logbook &&
        !vtAccount.features.dvir &&
        !vtAccount.features.workOrder;

    const iftaFeatureEnabled = !appState.attr("hideFuelReceipts") && vtAccount.features.ifta &&
        appState.attr("hasIftaPermission");

    // 1. If the current active account has no products and is an Admin
    // 2. If the current active account has products but limited permissions
    if (noProducts && userIsAccountAdmin) {
        can.route.attr("page", "settings");
        if (vtAccount.isReseller) {
            can.route.attr("slug", "accounts");
        } else if (appState.attr("hasProducts")) {
            can.route.attr("slug", "accounts-settings");
        }
    } else if (!noProducts && !userIsAccountAdmin &&
        appState.permissions.PERM_EDIT_EQUIPMENT) {
        can.route.attr("page", "settings");
        can.route.attr("slug", "equipment");
    }


    // 1. If the current active account has no products and has only `ifta` feature enabled
    // 2. If the current active account has products and has only `ifta` feature enabled
    if (
        (noProducts && iftaFeatureEnabled) ||
        !noProducts &&
        noFeatureProductsEnabled &&
        iftaFeatureEnabled
    ) {
        can.route.attr("page", "ifta");
        can.route.attr("slug", "fuel-receipts");
    }
}
